// extracted by mini-css-extract-plugin
export default {"wrap":"CopyAddress_wrap__oKono","icon":"CopyAddress_icon__MAf+I","popover":"CopyAddress_popover__iihLZ","fadeIn":"CopyAddress_fadeIn__qo5MY"};